// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ContactBlock-module-contactBlockWrapper-3Oxdw{display:inline-flex;gap:var(--spacing-3xl);flex-wrap:wrap}.ContactBlock-module-contactBlockWrapper-3Oxdw.ContactBlock-module-horizontal-1VCzJ{flex-direction:row}.ContactBlock-module-contactBlockWrapper-3Oxdw.ContactBlock-module-vertical-3UHPy{flex-direction:column;gap:var(--spacing-sl)}", ""]);
// Exports
exports.locals = {
	"contactBlockWrapper": "ContactBlock-module-contactBlockWrapper-3Oxdw",
	"horizontal": "ContactBlock-module-horizontal-1VCzJ",
	"vertical": "ContactBlock-module-vertical-3UHPy"
};
module.exports = exports;
